// Explicit catalog-label translations, not guesses based on an artist or album.
export const genreTranslations = {
  'Alternatif et Indé': 'Alternative & Indie',
  'Ambiance': 'Ambient',
  'Bandes originales de films': 'Film Soundtracks',
  'Brésil': 'Brazilian',
  'Classique': 'Classical',
  'Électronique': 'Electronic',
  'Jazz vocal': 'Vocal Jazz',
  'Jeux vidéo': 'Video Game Music',
  'Musique symphonique': 'Symphonic Music',
  'Musique vocale (profane et sacrée)': 'Vocal Music (Secular & Sacred)',
  'Musiques de Noël': 'Christmas Music',
  'Musiques du monde': 'World',
  'Rock progressif': 'Progressive Rock',
  'Rock y Alternativo': 'Rock & Alternative',
  'Funk Brasil': 'Brazilian Funk',
  'Alternative-Rock': 'Alternative Rock',
  'Hip-Hop': 'Hip Hop',
  'Punk / New Wave': 'Punk - New Wave',
  'Synthpop': 'Synth-Pop',
  'Synth Pop': 'Synth-Pop',
  'Darkwave': 'Dark Wave',
  // Spelling variants that share a URL; the library's most common spelling wins.
  'Post-Rock': 'Post Rock',
  'Hardcore Hip Hop': 'Hardcore Hip-Hop',
  'Rock And Roll': 'Rock & Roll',
  'Drum & Bass': 'Drum n Bass',
  'indie-pop': 'Indie Pop',
  'Dance-Pop': 'Dance-pop',
  'art pop': 'Art Pop',
  // Qobuz's root category; its child category carries the meaning.
  'Pop/Rock': 'Rock',
};
const key = (value) => value.normalize('NFC').trim().toLocaleLowerCase('en-US');
const translations = new Map(Object.entries(genreTranslations).map(([from, to]) => [key(from), to]));
export function normalizeGenre(value) {
  return translations.get(key(value)) ?? value;
}

// Comma-delimited tags split Discogs' "Folk, World, & Country" into three values.
const DISCOGS_FOLK = ['Folk', 'World', '& Country'];
function repairSplitLabels(values) {
  const start = values.findIndex((value, index) => DISCOGS_FOLK.every((part, offset) => values[index + offset] === part));
  if (start === -1) return values.filter((value) => !/^&\s/.test(value));
  return [...values.slice(0, start), 'Folk, World, & Country', ...values.slice(start + DISCOGS_FOLK.length)].filter((value) => !/^&\s/.test(value));
}

export function normalizeGenres(values) {
  const genres = [...new Set(repairSplitLabels(values.map((value) => value.trim()).filter(Boolean)).map(normalizeGenre))];
  // Qobuz tags its "Pop/Rock" root as separate Pop and Rock values; Rock is the specific branch.
  return genres.includes('Rock') ? genres.filter((genre) => genre !== 'Pop') : genres;
}
